@if (ocr && checksDetail) {
    <tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.REQUIREMENTS' | translate">
        @if (hasRequirementsContent) {
            <app-operation-ocr-checks-requirements [checksDetail]="checksDetail" />
        } @else {
            <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
        }
    </tec-tile>

    <tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.COMPARE_INFO' | translate">
        @if (hasCompareContent) {
            @if (hasOcrCompareChecks(ocr)) {
                <app-operation-ocr-checks-compare-info
                    [checksDetail]="checksDetail"
                    [extraChecks]="compareExtraChecks"
                />
            }
            @if (formMatchChecksDetail) {
                <app-operation-form-checks-compare-info [checksDetail]="formMatchChecksDetail" />
            }
        } @else {
            <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
        }
    </tec-tile>

    <tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.ANTIFRAUD' | translate">
        @if (hasAntifraudContent) {
            @if (ocr?.state) {
                <span style="display: inline-flex; gap: 6px; align-items: center; margin-bottom: 8px;">
                    {{ ('PROCESSES.DETAIL.OCR' | translate).toUpperCase() }}
                    <tec-tag
                        [label]="'MASTER.STATUS.' + ocr.state | translate"
                        [status]="masterService.getTagStatus(ocr.state)"
                    />
                </span>
            }
            <app-operation-ocr-checks-antifraud [checksDetail]="checksDetail" [checks]="antifraudChecks" />
        } @else {
            <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
        }
    </tec-tile>
} @else {
    <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
}
